<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCsvTable(titleChart)" @zoomEnabled="zoomEnabled" @zoomDisabled="zoomDisabled" :downloadId="downloadId" :isZoomEnabled="false" :specificSiteId="specificSiteId" :downloadShow="dataList.length > 0">
    <table slot="body" class="table table-hover table-borderless mt-10">
      <tbody>
        <div v-if="dataList.length > 0">
          <tr v-for="(item, index) in dataList" :key="index">
            <td style="width: 2px" class="top-time-activity-text">
              <span>
                <svg width="12" height="12" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.2505 8.70833H4.58382C4.2523 8.70833 3.93436 8.58322 3.69994 8.36052C3.46552 8.13782 3.33382 7.83578 3.33382 7.52083V5.54177H1.66684V17.4168H5.83382V13.0625H10.0005V17.4168H14.1668V5.54177H12.5005V7.52083C12.5005 7.83578 12.3688 8.13782 12.1344 8.36052C11.9 8.58322 11.582 8.70833 11.2505 8.70833ZM12.5005 3.95844V1.1875C12.5005 0.872555 12.3688 0.57051 12.1344 0.347811C11.9 0.125111 11.582 0 11.2505 0H4.58382C4.2523 0 3.93436 0.125111 3.69994 0.347811C3.46552 0.57051 3.33382 0.872555 3.33382 1.1875V3.95844H1.25017C0.918649 3.95844 0.600707 4.08355 0.366287 4.30625C0.131866 4.52894 0.000169754 4.83099 0.000169754 5.14594V17.8126C0.000169754 18.1275 0.131866 18.4296 0.366287 18.6523C0.600707 18.875 0.918649 19.0001 1.25017 19.0001H14.5835C14.915 19.0001 15.233 18.875 15.4674 18.6523C15.7018 18.4296 15.8335 18.1275 15.8335 17.8126V5.14594C15.8335 4.83099 15.7018 4.52894 15.4674 4.30625C15.233 4.08355 14.915 3.95844 14.5835 3.95844H12.5005ZM5.00049 7.125H10.8338V1.58333H5.00049V7.125ZM8.75016 6.33344H7.0835V5.14594H5.83382V3.5626H7.0835V2.3751H8.75016V3.5626H10.0005V5.14594H8.75016V6.33344Z"
                      :fill="primaryColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="15.8333" height="19.0001" fill="white" transform="matrix(-1 0 0 1 15.8335 0)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </td>
            <td style="width: 5px" class="top-time-activity-text-padding-right">
              <span class="top-time-activity-text-number ml-4"> {{ index + 1 }}</span>
            </td>
            <td style="text-align: left" class="top-time-activity-text">
              {{ item.siteName }}
            </td>
            <td style="text-align: right" class="top-time-activity-text">
              <span>{{ Math.round(item.numParticipant) }}</span>
            </td>
          </tr>
        </div>

        <div v-else class="align-center p-60">
          <div class="card-text-title no-data" v-if="dataLoaded">
            No Data In
          </div>
        </div>
      </tbody>
    </table>
  </chart-container>
</template>

<script>
import { downloadCSV } from "../../services/visualization/data-management";
import ChartContainer from "./chart-container.vue";
import _ from "lodash";

export default {
  components: {
    ChartContainer
  },
  props: {
    titleChart: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => [] },
    fromDate: { type: String, default: "" },
    toDate: { type: String, default: "" },
    sitesSelected: { type: Array, default: () => [] },
    zoomGraphValue: { type: String, default: "" },
    studyEnrollmentRawData: { type: Object, default: () => {} },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      downloadId: "top5site",
      dataList: [],
      rawData: [],
      primaryColor: "#7F69D5"
    };
  },
  methods: {
    zoomEnabled() {
      this.$emit("zoomEnabled");
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
    },
    generateParticipantEnrollData(enrollmentRawData) {
      return _.filter(enrollmentRawData, site => {
        return this.sitesSelected === "all" || this.sitesSelected[0] === "all" || this.sitesSelected.indexOf(site.siteName) >= 0;
      });
    },
    downloadCsvTable(title) {
      if (_.isEmpty(this.dataList)) {
        return;
      }
      let csvHeaders;
      const csvContent = [];
      csvHeaders = ["Site Name", "Participants"];
      this.dataList.map(item => csvContent.push([item.siteName, item.numParticipant]));
      downloadCSV(title, csvHeaders, csvContent, this.specificSiteId);
    }
  },
  async mounted() {
    let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
    this.primaryColor = primaryColor || "#7F69D5";
  },
  watch: {
    sitesSelected: function() {
      this.dataList = this.generateParticipantEnrollData(this.rawData);
    },
    studyEnrollmentRawData: function(newValue) {
      if (newValue) {
        const orderBy = _.orderBy(this.studyEnrollmentRawData.topFiveSites, ["numParticipant"], ["desc"]);
        this.rawData = orderBy;
        this.dataList = this.generateParticipantEnrollData(orderBy);
      }
    }
  }
};
</script>
